module.exports = __webpack_public_path__ + "static/img/13areaA_1.8054620.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/13areaA_1.png
// module id = 1001
// module chunks = 1